import { operatorApiFetch } from './apiService';

export const shelfMovementService = {
  // 列表
  getRecords: async (params) => {
    const response = await operatorApiFetch('shelf_movements/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('shelf_movements/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },
  export: async (ids) => {
    const res = await operatorApiFetch('shelf_movements/export', {
      method: 'POST',
      body: { ids }
    });
    return res.json();
  }
};

export default shelfMovementService;
